function Forbidden() {
  return <h1 className="d-flex justify-content-center d-flex align-items-center min-vh-100">Forbidden</h1>;
}

export default Forbidden;
